import angular from "angular";

import { SignatureMethod, SignatureService } from "../../../services";

/**
 * Handles user interaction for Digital Signature
 */
export class SignatureController implements angular.IController {

    /**
     * For NG-dependency injection
     * @ignore
     */
    public static $inject = [
        "SignatureService",
    ];

    /**
     * Creates a new SignatureController
     * @param signatureService - Service that handles the communication to the server
     * @ignore
     */
    constructor(private signatureService: SignatureService) {
    }

    /**
     * Implement IController
     */
    public $onInit = () => {
        //
    };

    /**
     * Legacy list of supported Visma Sign Signature methods.
     */
    public get methods() {
        return this.getMethods("tupas");
    }

    /**
     * List of supported Signature methods
     * @param methodGroup - Method group "telia" for Telia Tunnistus and "tupas" for Visma Sign. Default is "tupas".
     */
    public getMethods(methodGroup: "tupas" | "telia" = "tupas") {
        return this.signatureService.getMethods(methodGroup);
    }

    /**
     * Returns the SignatureMethod for given value.
     * @param value - value for SignatureMethod, e.g. tupas-nordea.
     */
    public getMethod(value: string): SignatureMethod {
        return this.signatureService.getMethods("tupas").find( (x) => x.value === value)
        ?? this.signatureService.getMethods("telia").find( (x) => x.value === value);
    }
}
